import React, {useState} from "react";
import styles from "./DocumentsFER.scss"
import {useAppText} from "src/commun/composants/AppText";
import {useAsync} from "react-async-hook";
import AppCol from "src/commun/composants/grille/AppCol";
import {Document} from "src/domain/Document";
import AppIcon from "src/commun/composants/AppIcon";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import {downloadDocument, getDocuments} from "src/app/api/DocumentApi";
import AppRow from "../../commun/composants/grille/AppRow";

const DocumentsFER = () => {
  const {tString} = useAppText();
  const [error, setError] = useState(null);
  const documents = useAsync(getDocuments, []);

  const renderHead = () => {
    return (
      <tr>
        <th>{tString("documents.column.date")}</th>
        <th>{tString("documents.column.type")}</th>
        <th>{tString("documents.column.originalFilename")}</th>
        <th></th>
      </tr>
    )
  }

  const renderLine = (document: Document) => {
    return (
      <tr>
        <td>{document.date}</td>
        <td>{document.type}</td>
        <td>{document.originalFilename}</td>
        <td>
          <AppIcon
            name="tlcharger"
            className={styles.iconDownload}
            active
            size="38px"
            onClick={() => {
              setError(null);
              downloadDocument(document.id)
                .catch(err => setError(err));
            }}
          />
        </td>
      </tr>
    )
  }

  if (documents.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md={{span: 11}}>
            <div className={`${styles.container} ${styles.documents}`}>
              <h2 className="appTitle">{tString("documents.title")}</h2>

              {error && <AppMessage messageType="ERROR" children={<>{tString("error.technical")}</>}/>}

              {(!documents.result || documents.result.length === 0) ?
                <AppMessage messageType="INFO" children={<>{tString("documents.info.pasDeDocuments")}</>}/>
                :
                (
                  <table className={styles.tableDocuments}>
                    <thead>
                    {renderHead()}
                    </thead>
                    <tbody>
                    {documents.result?.map((document) => renderLine(document))}
                    </tbody>
                  </table>
                )
              }

            </div>
        </AppCol>
      </AppRow>
    </span>
  );
};

export default DocumentsFER;